module.exports = __webpack_public_path__ + "static/media/3.b7aa502f.svg";